import React from 'react';

export function GraphIcon(): JSX.Element {
  return (
    <svg fill='none' height='16' viewBox='0 0 16 16' width='16' xmlns='http://www.w3.org/2000/svg'>
      <path
        clipRule='evenodd'
        d='M15.2387 14.8107C15.2387 14.5219 15.0057 14.2878 14.7183 14.2878L1.18712 14.2878C0.89969 14.2878 0.666686 14.5219 0.666686 14.8107C0.666686 15.0995 0.89969 15.3337 1.18712 15.3337L14.7183 15.3337C15.0057 15.3337 15.2387 15.0995 15.2387 14.8107Z'
        fill='#2C3236'
        fillRule='evenodd'
      />
      <path
        clipRule='evenodd'
        d='M15.3334 1.18993C15.3334 0.901121 15.1003 0.666993 14.8129 0.666993L10.6495 0.666993C10.3621 0.666993 10.129 0.901121 10.129 1.18993L10.129 14.7864C10.129 15.0752 10.362 15.3093 10.6495 15.3093L14.8129 15.3093C15.1003 15.3093 15.3334 15.0752 15.3334 14.7864L15.3334 1.18993ZM14.2925 1.71287L14.2925 14.2634L11.1699 14.2634L11.1699 1.71287L14.2925 1.71287Z'
        fill='#2C3236'
        fillRule='evenodd'
      />
      <path
        clipRule='evenodd'
        d='M11.1187 5.35524C11.1187 5.06643 10.8857 4.8323 10.5982 4.8323L6.34805 4.8323C6.06063 4.8323 5.82762 5.06643 5.82762 5.35524L5.82762 14.8107C5.82762 15.0995 6.06063 15.3337 6.34805 15.3337L10.5982 15.3337C10.8857 15.3337 11.1187 15.0995 11.1187 14.8107L11.1187 5.35524ZM10.0778 5.87818L10.0778 14.2878L6.86848 14.2878L6.86848 5.87818L10.0778 5.87818Z'
        fill='#2C3236'
        fillRule='evenodd'
      />
      <path
        clipRule='evenodd'
        d='M6.86848 9.93198C6.86848 9.64317 6.63548 9.40904 6.34805 9.40904L2.40145 9.40904C2.11403 9.40904 1.88102 9.64317 1.88102 9.93198L1.88102 14.8107C1.88102 15.0995 2.11403 15.3337 2.40145 15.3337L6.34805 15.3337C6.63548 15.3337 6.86848 15.0995 6.86848 14.8107L6.86848 9.93198ZM5.82762 10.4549L5.82762 14.2878L2.92188 14.2878L2.92188 10.4549L5.82762 10.4549Z'
        fill='#2C3236'
        fillRule='evenodd'
      />
    </svg>
  );
}
